import { DeliveryTypeDef } from '@api/types/DeliveryTypeDef';
import { PaymentTypeDef } from '@api/types/PaymentTypeDef';
import { DispatchPoint } from '@api/types/DispatchPoint';
import { AppLanguageCode } from '@project-types/AppLanguageCodes';
import { getCurrentLanguageCode } from '@translations/functions';



export interface OrderState {
	showInvalids: boolean,
	sizeA: number | null,
	sizeB: number | null,
	sizeC: number | null,
	race: string | null,
	age: number | null,
	behaviourDesc: string | null,
	surgerySegments: string[],
	issueDesc: string | null,
	surgeryDate: string | null,
	name: string | null,
	email: string | null,
	phoneNumber: string | null,

	street: string | null,
	city: string | null,
	postalCode: string | null,
	invoiceStreet: string | null,
	invoiceCity: string | null,
	invoicePostalCode: string | null,
	
	selectedType: number | null,
	collarType: string | null,
	message: string | null,
	payment: PaymentTypeDef | null,
	delivery: DeliveryTypeDef | null,
	dispatchPoint: DispatchPoint | null,
	discountCode: string | null,
	imageBase64: string | null,
	country: AppLanguageCode,
	sourceRef: string | null,
};


export const initialState: OrderState = {
	showInvalids: false,
	sizeA: null,
	sizeB: null,
	sizeC: null,
	race: null,
	age: null,
	behaviourDesc: null,
	surgerySegments: [],
	issueDesc: null,
	surgeryDate: null,
	name: null,
	email: null,
	phoneNumber: null,

	street: null,
	city: null,
	postalCode: null,
	invoiceStreet: null,
	invoiceCity: null,
	invoicePostalCode: null,
	
	selectedType: null,
	collarType: null,
	message: null,
	payment: null,
	delivery: null,
	dispatchPoint: null,
	discountCode: null,
	imageBase64: null,
	country: getCurrentLanguageCode(),
	sourceRef: null,
};